import axios from 'axios';
export function getCSRFToken() {
    const meta = document.querySelector('meta[name="csrf-token"]');
    if (!meta) {
        throw new Error('Unable to find CSRF token meta');
    }
    const csrfToken = meta.getAttribute('content');
    if (!csrfToken) {
        throw new Error('Unable to get CSRF token value');
    }
    return csrfToken;
}
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
axios.defaults.headers.common['X-CSRF-Token'] = getCSRFToken();
function setJSONHeaders(config = {}) {
    return Object.assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, config);
}
export function isNetworkError(error) {
    return error.message === 'Network Error';
}
export function get(url, config = {}) {
    return axios.get(url, config);
}
export function getJSON(url, config = {}) {
    return axios.get(url, setJSONHeaders(config));
}
export function getJSONCancellable(url, config = {}) {
    const source = axios.CancelToken.source();
    const configWithCancelToken = Object.assign({}, config, {
        cancelToken: source.token,
    });
    return { promise: getJSON(url, configWithCancelToken), source };
}
export function post(url, data = {}, config = {}) {
    return axios.post(url, data, config);
}
export function postJSON(url, data = {}, config = {}) {
    return axios.post(url, data, setJSONHeaders(config));
}
export function put(url, data = {}, config = {}) {
    return axios.put(url, data, config);
}
export function putJSON(url, data, config = {}) {
    return axios.put(url, data, setJSONHeaders(config));
}
export function patch(url, data, config = {}) {
    return axios.patch(url, data, config);
}
export function patchJSON(url, data, config = {}) {
    return axios.patch(url, data, setJSONHeaders(config));
}
// delete is a reserved keyword, so we can”s use it as named export :(
export function deleteRequest(url, config = {}) {
    return axios.delete(url, config);
}
export function deleteRequestJSON(url, config = {}) {
    return axios.delete(url, setJSONHeaders(config));
}
export function handleCancelRequest(error) {
    // When request is canceled, we just silence the error
    if (axios.isCancel(error)) {
        return;
    }
    throw error;
}
